// src/pages/GoodNews.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/GoodNews.css';

const API_URL = 'https://h9ijjeez6i.execute-api.us-east-1.amazonaws.com/prod/homily-feed';

export default function GoodNews() {
  const [homilyData, setHomilyData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [modalHomily, setModalHomily] = useState(null);

const formatDate = (dateStr) => {
  const date = new Date(dateStr + 'T00:00:00');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const result = `${monthNames[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  return result;
};

  const formatReading = (item) => {    
    // More permissive check - just need the values to exist (even if empty string)
    if (item.book !== undefined && item.chapter !== undefined && item.verse !== undefined) {
      const result = `${item.book || 'Unknown'} ${item.chapter || '?'}:${item.verse || '?'}`;
      return result;
    }
    return item.verse || '...';
  };

  const fetchPage = async (page) => {
    try {
      setLoading(true);
      const timestamp = Date.now();
      const url = `${API_URL}?page=${page}&_t=${timestamp}`;
      
      const response = await fetch(url);
          
      const data = await response.json();
            
      let parsed = [];
      let pages = 1;
      let totalCount = 0;
      
      if (data.Items && Array.isArray(data.Items)) {
        parsed = data.Items;
        pages = data.totalPages || 1;
        totalCount = data.totalCount || 0;

      } else if (data.body) {
        const bodyData = JSON.parse(data.body);
        console.log('📦 Parsed body:', JSON.stringify(bodyData, null, 2));
        if (bodyData.Items && Array.isArray(bodyData.Items)) {
          parsed = bodyData.Items;
          pages = bodyData.totalPages || 1;
          totalCount = bodyData.totalCount || 0;

        }
      } else {
        console.log('❌ No Items found in response');
        console.log('   - Response keys:', Object.keys(data));
      }

      setHomilyData(parsed);
      setCurrentPage(page);
      setTotalPages(pages);

    } catch (error) {
      console.error('💥 Fetch error:', error);
      setHomilyData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPage(1);
  }, []);

  const handlePageChange = (page) => {

    if (page !== currentPage && page >= 1 && page <= totalPages) {
      console.log(`✅ FRONTEND: Calling fetchPage(${page})`);
      fetchPage(page);
    } else {
      console.log(`❌ FRONTEND: Not calling fetchPage - condition failed`);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      {loading && <p style={{ textAlign: 'center', padding: '40px 0' }}>Loading homilies...</p>}

      {!loading && homilyData.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <p>No homilies found.</p>
          <p style={{ fontSize: '12px', color: '#666' }}>Check console for debugging info.</p>
        </div>
      )}

      {!loading && homilyData.length > 0 && (
        <div style={{ backgroundColor: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '8px', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ backgroundColor: '#f9fafb' }}>
              <tr>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase', width: '120px' }}>Date</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase', width: '150px' }}>Reading</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Gospel</th>
                <th style={{ padding: '12px 16px', textAlign: 'left', fontSize: '12px', fontWeight: '500', color: '#6b7280', textTransform: 'uppercase' }}>Homily</th>
              </tr>
            </thead>
            <tbody>
              {homilyData.map((item, idx) => {                
                return (
                <tr 
                  key={item.timestamp || `${item.date}-${item.book || ''}-${item.chapter || ''}-${item.verse || ''}`} 
                  onClick={() => setModalHomily(item)} 
                  style={{ 
                    cursor: 'pointer', 
                    borderTop: idx > 0 ? '1px solid #e5e7eb' : 'none',
                    backgroundColor: idx % 2 === 1 ? '#f9fafb' : 'white'
                  }}
                  onMouseEnter={(e) => e.target.closest('tr').style.backgroundColor = '#f3f4f6'}
                  onMouseLeave={(e) => e.target.closest('tr').style.backgroundColor = idx % 2 === 1 ? '#f9fafb' : 'white'}
                >
                  <td style={{ padding: '8px 16px', fontSize: '14px', fontWeight: '500', color: '#111827', whiteSpace: 'nowrap' }}>{item.date}</td>
                  <td style={{ padding: '8px 16px', fontSize: '14px', color: '#111827', whiteSpace: 'nowrap' }}>{item.book} {item.chapter}:{item.verse}</td>
                  <td style={{ padding: '8px 16px', fontSize: '14px', color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '300px' }}>{item.gospelText}</td>
                  <td style={{ padding: '8px 16px', fontSize: '14px', color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '300px' }}>{item.homilyText}</td>
                </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {!loading && totalPages > 1 && (
        <div style={{ marginTop: '24px' }}>
          <ul style={{ display: 'flex', justifyContent: 'center', gap: '4px', listStyle: 'none', padding: 0, margin: 0, color: '#111827' }}>
            <li>
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                style={{
                  display: 'grid',
                  placeContent: 'center',
                  width: '32px',
                  height: '32px',
                  borderRadius: '4px',
                  border: '1px solid #e5e7eb',
                  backgroundColor: 'white',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  opacity: currentPage === 1 ? 0.5 : 1
                }}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </li>
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              const pageNum = i + Math.max(1, currentPage - 2);
              if (pageNum > totalPages) return null;
              return (
                <li key={pageNum}>
                  {pageNum === currentPage ? (
                    <span style={{
                      display: 'block',
                      width: '32px',
                      height: '32px',
                      borderRadius: '4px',
                      border: '1px solid #4f46e5',
                      backgroundColor: '#4f46e5',
                      color: 'white',
                      textAlign: 'center',
                      lineHeight: '30px',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}>
                      {pageNum}
                    </span>
                  ) : (
                    <button
                      onClick={() => handlePageChange(pageNum)}
                      style={{
                        display: 'block',
                        width: '32px',
                        height: '32px',
                        borderRadius: '4px',
                        border: '1px solid #e5e7eb',
                        backgroundColor: 'white',
                        color: '#111827',
                        textAlign: 'center',
                        lineHeight: '30px',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: 'pointer'
                      }}
                    >
                      {pageNum}
                    </button>
                  )}
                </li>
              );
            })}
            <li>
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                style={{
                  display: 'grid',
                  placeContent: 'center',
                  width: '32px',
                  height: '32px',
                  borderRadius: '4px',
                  border: '1px solid #e5e7eb',
                  backgroundColor: 'white',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  opacity: currentPage === totalPages ? 0.5 : 1
                }}
              >
                <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      )}

      {modalHomily && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '16px'
          }} 
          onClick={() => setModalHomily(null)}
        >
          <div 
            style={{
              backgroundColor: 'white',
              borderRadius: '8px',
              maxWidth: '800px',
              maxHeight: '90vh',
              overflowY: 'auto',
              width: '100%',
              position: 'relative'
            }} 
            onClick={e => e.stopPropagation()}
          >
            <button 
              onClick={() => setModalHomily(null)}
              style={{
                position: 'absolute',
                top: '16px',
                right: '16px',
                background: 'none',
                border: 'none',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#6b7280',
                cursor: 'pointer',
                zIndex: 10
              }}
            >
              ×
            </button>
            <div style={{ padding: '24px' }}>
              <h3 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', paddingRight: '32px' }}>{formatDate(modalHomily.date)}</h3>
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '8px' }}>
                  Reading:
                </h4>
                <p style={{ color: '#374151' }}>{formatReading(modalHomily)}</p>
              </div>
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '8px' }}>Gospel:</h4>
                <p style={{ color: '#374151', lineHeight: '1.6' }}>{modalHomily.gospelText}</p>
              </div>
              <div>
                <h4 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', marginBottom: '8px' }}>Homily:</h4>
                <div style={{ color: '#374151', lineHeight: '1.6' }}>
                  {modalHomily.homilyText.split('\n').map((para, i) => (
                    <p key={i} style={{ marginBottom: '12px' }}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}